<!-- engage hitmaker page start -->
<div >
<div class="urlDiv" fxLayout="row wrap">
<a class="urls" href="/userProfiles/{{userId}}?home=false">
  Home /
</a>
<a  class="urls" href="/hitmaker">
   &nbsp;Hitmaker
</a>
</div>
    <div class="image-div" fxLayout="column wrap">

        <img class="image" style="height: 40vh;
        width: 100vw;" [src]="mainBannerImg" alt="Banner Image">

    </div>   
    <div class="container">

      <ng-container *ngIf="mainTitle">
        <br>
        <p class="engageTitle"><strong>{{mainTitle}}</strong></p>
      </ng-container>
      
      <ng-container *ngIf="mainDesc">
        <br>
        <span class="newPara" style=" font-size: 18px;
        line-height: 22px;
        font-family: 'Lato', sans-serif;
        line-break: auto;
        display: flex;
        flex-flow: row wrap;
        padding:0 6%;">{{mainDesc}}</span>
        <br>
      </ng-container>
  
  <div  fxLayout="row wrap" style="justify-content: center;" >
      
      <div class="movie-banner"  *ngFor="let movie of moviesList">
        <img class="imgBanner" [src]="movie.bannerUrl" (click)="getMovieDetails(movie)">
        <div class="names" (click)="getMovieDetails(movie)">
            <span >{{movie.name}}</span>
        </div>
       
      </div> 
    
  </div>
    </div>
  </div>
